import Lenis from "lenis";

export const lenis = new Lenis({
  autoRaf: true,
});
